import React from 'react'
import DefaultTemplate from './templates/DefaultTemplate'
import EducationTemplate from './templates/EducationTemplate'
import EventTemplate from './templates/EventTemplate'
import ExchangeCourseTemplate from './templates/ExchangeCourseTemplate'
import LocalPageTemplate from './templates/LocalPageTemplate'
import NewsTemplate from './templates/NewsTemplate'
import OrganizationPageTemplate from './templates/OrganizationPageTemplate'
import OrganizationTemplate from './templates/OrganizationTemplate'
import PersonTemplate from './templates/PersonTemplate'
import ProgrammePageTemplate from './templates/ProgrammePageTemplate'
import QuickLinkTemplate from './templates/QuicklinkTemplate'
import ResearchProjectTemplate from './templates/ResearchProjectTemplate'
import ResearchStoryTemplate from './templates/ResearchStoryTemplate'
import SyllabusTemplate from './templates/SyllabusTemplate'

function ResultTemplateSwitch(props) {
  const { type } = props
  /**
   * p.g.a att omskrivningar för typ på hits som har syllabus har skrivit om från syllabus till kurs/program
   * därför testar vi om det finns en syllabus array
   * */
  if (
    !props.body &&
    !props.course_type &&
    (props.syllabuses || props.reading_lists)
  ) {
    return <SyllabusTemplate {...props} />
  }
  switch (type) {
    case '__quicklink__':
      return <QuickLinkTemplate {...props} />
    case 'rich_page':
    case 'research':
    case 'education_information':
    case 'information_page':
    case 'landing_page':
    case 'space_landing_page':
    case 'spaces_contact_page':
    case 'spaces_front_page':
    case 'stripped_page':
      return <DefaultTemplate {...props} />
    case 'news':
      return <NewsTemplate {...props} />
    case 'research_project':
      return <ResearchProjectTemplate {...props} />
    case 'research_story':
      return <ResearchStoryTemplate {...props} />
    case 'event':
      return <EventTemplate {...props} />
    case 'education':
      return <EducationTemplate {...props} />
    case 'syllabus':
      return <SyllabusTemplate {...props} />
    case 'person':
      return <PersonTemplate {...props} />
    case 'organization':
      return <OrganizationTemplate {...props} />
    case 'exchange_course':
      return <ExchangeCourseTemplate {...props} />
    case 'local_page':
      return <LocalPageTemplate {...props} />
    case 'programme_page':
      return <ProgrammePageTemplate {...props} />
    case 'organization_page':
      return <OrganizationPageTemplate {...props} />
    default:
      return <DefaultTemplate {...props} />
  }
}

export default ResultTemplateSwitch
